<div class="om-toolbar oa-toolbar">
  <app-search-bar
    class="oa-search"
    data-testid="oa-search"
    [placeholder]="'objectMappings.assignment.searchPlaceholder' | translate"
    [value]="search()"
    (valueChange)="search.set($event)"
  />
  <div
    class="oa-chips"
    role="group"
    data-testid="oa-chips"
    [attr.aria-label]="'objectMappings.assignment.actionLabel' | translate"
  >
    @for (chip of chips(); track chip.key) {
      <app-filter-chip
        [attr.data-testid]="'oa-chip-' + chip.key"
        [label]="chip.label | translate"
        [count]="chip.count"
        [pill]="true"
        [active]="chip.active"
        (clicked)="selectAction(chip.action)"
      />
    }
  </div>
</div>

@if (ready() && openRows().length > 0) {
  <section class="oa-open" data-testid="oa-open">
    <div class="oa-open__head">
      <mat-icon aria-hidden="true">shield</mat-icon>
      <strong data-testid="oa-open-title">{{ openTitleKey() | translate: { count: openRows().length } }}</strong>
    </div>
    @for (row of openRows(); track row.id) {
      <div class="oa-open__row" data-testid="oa-open-row">
        <code class="oa-open__ref">{{ libraryName() }}.{{ row.object }}</code>
        <span class="oa-pill" data-testid="oa-open-action" [attr.data-action]="row.action">
          {{ 'objectMappings.assignment.action.' + row.action | translate }}
        </span>
        <a class="oa-open__owner" data-testid="oa-open-owner" [routerLink]="ownerLink(row)">{{ ownerStep(row) }}</a>
        <span class="oa-open__title" data-testid="oa-open-title-owner">{{ row.ownerTitle }}</span>
        @if (!readOnly() && row.object) {
          <button mat-stroked-button type="button" data-testid="oa-create" (click)="createObject.emit(row.object)">
            <mat-icon aria-hidden="true">add</mat-icon>
            {{ 'objectMappings.assignment.createObject' | translate }}
          </button>
        }
      </div>
    }
  </section>
}

<div class="om-card oa-card" data-testid="oa-table">
  <div class="om-table-header" data-testid="oa-table-head" aria-hidden="true">
    <div class="om-col oa-col--object">{{ 'objectMappings.assignment.table.object' | translate }}</div>
    <div class="om-col oa-col--action">{{ 'objectMappings.assignment.table.action' | translate }}</div>
    <div class="om-col oa-col--expectation">{{ 'objectMappings.assignment.table.expectation' | translate }}</div>
    <div class="om-col oa-col--owner">{{ 'objectMappings.assignment.table.owner' | translate }}</div>
    <div class="om-col oa-col--step">{{ 'objectMappings.assignment.table.step' | translate }}</div>
  </div>

  @switch (status()) {
    @case ('laedt') {
      <div
        class="oa-skeleton"
        role="status"
        data-testid="oa-loading"
        [attr.aria-label]="'objectMappings.assignment.loading' | translate"
      >
        @for (line of skeletonRows; track line) {
          <div class="om-row" aria-hidden="true">
            <span class="oa-skeleton__bar oa-skeleton__bar--object"></span>
            <span class="oa-skeleton__bar oa-skeleton__bar--action"></span>
            <span class="oa-skeleton__bar oa-skeleton__bar--owner"></span>
          </div>
        }
      </div>
    }
    @case ('fehler') {
      <div class="om-hint om-hint--error" role="alert" data-testid="oa-error">
        <p>{{ 'objectMappings.assignment.loadError' | translate }}</p>
        <button mat-stroked-button type="button" data-testid="oa-retry" (click)="retry.emit()">
          {{ 'objectMappings.retry' | translate }}
        </button>
      </div>
    }
    @default {
      @for (row of shownRows(); track row.id) {
        <div
          class="om-row oa-row"
          role="button"
          tabindex="0"
          data-testid="oa-row"
          (click)="open(row)"
          (keydown.enter)="open(row)"
        >
          <div class="om-col oa-col--object">
            <code class="oa-ref">
              @if (row.object) {
                <span class="oa-ref__lib">{{ libraryName() }}.</span>
                <span class="oa-ref__name">{{ row.object }}</span>
              } @else {
                <span class="oa-ref__name">{{ libraryName() }}</span>
              }
            </code>
          </div>
          <div class="om-col oa-col--action">
            <span class="oa-pill" [attr.data-action]="row.action">
              {{ 'objectMappings.assignment.action.' + row.action | translate }}
            </span>
          </div>
          <div class="om-col oa-col--expectation" data-testid="oa-expectation" [class.oa-code]="!!row.expectation">
            {{ row.expectation || '—' }}
          </div>
          <div class="om-col oa-col--owner">
            <app-icon [name]="row.ownerKind === 'MODULE' ? 'puzzle' : 'folder'" [size]="13" />
            <code class="oa-owner__key">{{ row.ownerKey }}</code>
            <span class="oa-owner__title">{{ row.ownerTitle }}</span>
          </div>
          <div class="om-col oa-col--step">{{ row.stepKey }}</div>
        </div>
      } @empty {
        <p class="om-hint oa-empty" data-testid="oa-empty">
          {{
            (rows().length > 0 ? 'objectMappings.assignment.emptyFiltered' : 'objectMappings.assignment.empty')
              | translate
          }}
        </p>
      }
    }
  }
</div>
<p class="oa-footnote" data-testid="oa-footnote">{{ 'objectMappings.assignment.footnote' | translate }}</p>
